import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {GqlCustomerService} from "../../../checkout/graphql/customer/gql-customer.service";
import {map, switchMap} from "rxjs/operators";
import {Customer} from "../../../checkout/models/customer/customer";
import {from, Observable} from "rxjs";
import {AoUpsellService} from "../ao-upsell/ao-upsell.service";
import {IInitialOrderReward} from "../../autoorder/auto-order-models";
import {TranslateService} from "../../translation/translate.service";
import {UsanaCurrencyPipe} from "../../currency/usana-currency.pipe";
import {GqlAutoOrderService} from "../../../checkout/graphql/autoorder/gql-auto-order.service";
import {ICart} from "../../cart/cart-models";
import {GqlCartService} from "../../cart/graphql/gql-cart.service";

@Component({
    selector: 'ior',
    templateUrl: './initial-order-reward.component.html',
    styleUrls: ['./initial-order-reward.component.scss'],
    standalone: false
})
export class InitialOrderRewardComponent extends BaseComponent implements OnInit, OnChanges {

    @Input() cart: ICart;
    isFirstOrder$: Observable<boolean>;
    isFirstOrder: boolean;
    totalIoReward: number;
    learnMoreTranslation: string;
    iorSaveMessageTranslation: string;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private gqlCustomerService: GqlCustomerService,
        private gqlAutoOrderService: GqlAutoOrderService,
        private gqlCartService: GqlCartService,
        private aoUpsellService: AoUpsellService,
        private translateService: TranslateService,
        private usanaCurrencyPipe: UsanaCurrencyPipe
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.isFirstOrder$ = this.gqlCustomerService.getCustomer().pipe(
            map((customer: Customer) => {
                this.isFirstOrder = customer.config.firstOrder;
                if (!this.isFirstOrder) {
                    this.getTotalIoReward(customer.id);
                } else {
                    this.getPotentialIoReward();
                }
                return this.isFirstOrder;
            })
        );

        this.translateService.translate('cart.checkout.ior.learn.more.content').then((translation: string) => {
            this.learnMoreTranslation = translation;
        });

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.cart?.currentValue && this.isFirstOrder) {
            this.cart = changes.cart.currentValue;
            this.getPotentialIoReward();
        }
    }

    getIorSaveMessage(reward: number): Observable<string> {
        return this.usanaCurrencyPipe.transform(reward).pipe(
            switchMap((rewardAmount: string) => {
                return from(this.translateService.translateRequest({
                    tag: 'cart.checkout.ior.save.message',
                    replacements: new Map([['totalIoReward', rewardAmount]])
                }));
            })
         );
    }

    getTotalIoReward(customerId: number) {
        this.gqlAutoOrderService.getInitialOrderReward(customerId).subscribe((ior: IInitialOrderReward) => {
            if (ior?.totalIoReward) {
                this.setTotalIoReward(Math.abs(ior.totalIoReward));
            }
        });
    }

    getPotentialIoReward() {
        this.gqlCartService.getPotentialIorDiscount(this.cart).subscribe((iorDiscount: number) => {
            if (iorDiscount) {
                this.setTotalIoReward(Math.abs(iorDiscount));
            } else {
                this.setTotalIoReward(null);
            }
        });
    }

    setTotalIoReward(amount) {
        this.totalIoReward = amount;
        this.aoUpsellService.totalIoReward.next(amount);
        if (amount) {
            this.getIorSaveMessage(amount).subscribe((message: string) => this.iorSaveMessageTranslation = message);
        } else {
            this.iorSaveMessageTranslation = "";
        }
    }

}
